import {
  Button,
  HeadingText,
  ParagraphText,
  StackLayout,
  Box,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';
import { useNavigate } from 'react-router-dom';
import { OnboardingCard } from 'components/onboarding/onboarding-card/onboarding-card.component';
import { OnboardingMachineContext } from 'components/onboarding/onboarding.machine';
import allSetIllustration from 'assets/all-set-illustration.svg';

export const AllSetView = () => {
  const { formatMessage } = useIntl();
  const { send } = OnboardingMachineContext.useActorRef();
  const navigate = useNavigate();

  const handleStart = () => {
    // Navigate first so the route transition feels instant; the machine
    // transition to completingOnboarding unmounts this view in the same
    // render pass so the member never sees an interstitial flash.
    navigate(getModulePath(LEAGUE_MODULE_NAMES.assessment));
    send({ type: 'navigateToNextView' });
  };

  const handleSkip = () => send({ type: 'navigateToNextView' });

  return (
    <OnboardingCard>
      <StackLayout
        spacing="$twoAndHalf"
        horizontalAlignment="stretch"
        // Genesis spacing token (40px) rather than the Figma-spec 120px:
        // 120px each side leaves only ~80px content on a 320px viewport
        // and forces excessive wrapping. The slightly wider buttons at
        // desktop are an acceptable trade for responsive resilience and
        // consistency with the other onboarding cards.
        css={{
          paddingBlock: '$twoAndHalf',
          paddingInline: '$twoAndHalf',
        }}
      >
        <Box
          as="img"
          src={allSetIllustration}
          alt=""
          width={176}
          height={176}
          css={{ display: 'block', marginInline: 'auto' }}
        />

        <StackLayout spacing="$half" horizontalAlignment="center">
          <HeadingText
            size="lg"
            level="2"
            as="h1"
            css={{ textAlign: 'center' }}
          >
            {formatMessage({ id: 'STR_ALL_SET_HEADING' })}
          </HeadingText>
          <ParagraphText
            css={{
              textAlign: 'center',
              color: '$onSurfaceTextSubdued',
            }}
          >
            {formatMessage({ id: 'STR_ALL_SET_BODY' })}
          </ParagraphText>
        </StackLayout>

        <StackLayout spacing="$oneAndHalf" horizontalAlignment="stretch">
          <Button
            type="button"
            size="large"
            priority="primary"
            width="fillContainer"
            onClick={handleStart}
          >
            {formatMessage({ id: 'STR_ALL_SET_START_HEALTH_PROFILE' })}
          </Button>
          <Button
            type="button"
            size="large"
            priority="secondary"
            width="fillContainer"
            onClick={handleSkip}
          >
            {formatMessage({ id: 'STR_NOT_NOW' })}
          </Button>
        </StackLayout>
      </StackLayout>
    </OnboardingCard>
  );
};
